import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c66e7e88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "py-23" }
const _hoisted_2 = {
  key: 0,
  class: "vh-20 d-flex justify-content-center align-items-center"
}
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = {
  key: 1,
  class: "d-flex align-items-center header-title py-2 mb-2"
}
const _hoisted_5 = { class: "flex-fill" }
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = ["title"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-clockwise" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "list-area"
}
const _hoisted_13 = {
  key: 0,
  class: "item-area d-flex justify-centent-center align-items-center text-center small-fs py-2"
}
const _hoisted_14 = { class: "flex-fill p-2 basic-elt-cat me-2" }
const _hoisted_15 = ["onClick", "title"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash3-fill" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "d-flex align-items-center header-title py-2" }
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left-circle" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "flex-fill" }
const _hoisted_23 = ["title"]
const _hoisted_24 = { class: "form-cover" }
const _hoisted_25 = { for: "SubCode" }
const _hoisted_26 = ["placeholder", "disabled"]
const _hoisted_27 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_28 = { for: "NameEn" }
const _hoisted_29 = ["placeholder", "disabled"]
const _hoisted_30 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_31 = { for: "NameFr" }
const _hoisted_32 = ["placeholder", "disabled"]
const _hoisted_33 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_34 = { for: "NameRw" }
const _hoisted_35 = ["placeholder", "disabled"]
const _hoisted_36 = {
  key: 0,
  class: "my-1 error-style"
}
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = { for: "Description" }
const _hoisted_39 = ["placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["list-wrapper", {'d-none': _ctx.operationStatus !=0}])
    }, [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fa', 'fa-spinner'],
                class: "fs-1"
              }),
              _createElementVNode("p", null, _toDisplayString(_ctx.language.loading_subcategs), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.language.list_sub_categ), 1),
            _createTextVNode("  "),
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoEditRecord(0, null))),
              title: _ctx.language.add_new_subcateg
            }, _hoisted_8, 8, _hoisted_6),
            _createTextVNode("  "),
            _createElementVNode("a", {
              href: "javascript:;",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.reloadListSubCategs && _ctx.reloadListSubCategs(...args))),
              title: _ctx.language.reload
            }, _hoisted_11, 8, _hoisted_9)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_ctx.lstSubCategories.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.language.no_subcateg_found), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lstSubCategories, (oSubC) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "d-flex mb-2",
                key: oSubC.ProdCategoryId
              }, [
                _createElementVNode("span", _hoisted_14, " (" + _toDisplayString(oSubC.SubCode) + ") " + _toDisplayString(_ctx.getCategoryName(oSubC)), 1),
                _createElementVNode("a", {
                  href: "javascript:;",
                  onClick: ($event: any) => (_ctx.deleteRecord(oSubC)),
                  class: "text-danger",
                  title: _ctx.language.delete_subcateg
                }, _hoisted_17, 8, _hoisted_15)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["record-wrapper", {'d-none': _ctx.operationStatus !=1}])
    }, [
      _createElementVNode("h3", _hoisted_18, [
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goBackToList())),
          title: _ctx.language.all_sub_categs
        }, _hoisted_21, 8, _hoisted_19),
        _createTextVNode("  "),
        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.editorTitle), 1),
        _createTextVNode("  "),
        _createElementVNode("a", {
          href: "javascript:;",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveSubCategory())),
          title: _ctx.language.save_subcateg
        }, [
          _createVNode(_component_font_awesome_icon, { icon: ['fa', 'fa-save'] })
        ], 8, _hoisted_23)
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", {
          class: _normalizeClass(["form-group", { 'has-error': _ctx.f$.selectedRecord.SubCode.$error }])
        }, [
          _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.language.sub_code), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "SubCode",
            class: "capletter form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedRecord.SubCode) = $event)),
            placeholder: '(' + _ctx.language.sub_code.toLowerCase() + ')',
            maxlength: "10",
            autocomplete: "off",
            onFocus: _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord || _ctx.selectedRecord.ProdCategoryId != 0
          }, null, 40, _hoisted_26), [
            [_vModelText, _ctx.selectedRecord.SubCode]
          ]),
          (_ctx.f$.selectedRecord.SubCode.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.f$.selectedRecord.SubCode.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["form-group", { 'has-error': _ctx.f$.selectedRecord.NameEn.$error }])
        }, [
          _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.language.name + ' (en)'), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "NameEn",
            class: "form-control",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedRecord.NameEn) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ' (en))',
            maxlength: "25",
            autocomplete: "off",
            onFocus: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord
          }, null, 40, _hoisted_29), [
            [_vModelText, _ctx.selectedRecord.NameEn]
          ]),
          (_ctx.f$.selectedRecord.NameEn.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.f$.selectedRecord.NameEn.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["form-group", { 'has-error': _ctx.f$.selectedRecord.NameFr.$error }])
        }, [
          _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.language.name + ' (fr)'), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "NameFr",
            class: "form-control",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedRecord.NameFr) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ' (fr))',
            maxlength: "25",
            autocomplete: "off",
            onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord
          }, null, 40, _hoisted_32), [
            [_vModelText, _ctx.selectedRecord.NameFr]
          ]),
          (_ctx.f$.selectedRecord.NameFr.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.f$.selectedRecord.NameFr.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["form-group", { 'has-error': _ctx.f$.selectedRecord.NameRw.$error }])
        }, [
          _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.language.name + ' (rw)'), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            id: "NameRw",
            class: "form-control",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedRecord.NameRw) = $event)),
            placeholder: '(' + _ctx.language.name.toLowerCase() + ' (rw))',
            maxlength: "25",
            autocomplete: "off",
            onFocus: _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord
          }, null, 40, _hoisted_35), [
            [_vModelText, _ctx.selectedRecord.NameRw]
          ]),
          (_ctx.f$.selectedRecord.NameRw.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, _toDisplayString(_ctx.f$.selectedRecord.NameRw.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.language.description), 1),
          _withDirectives(_createElementVNode("textarea", {
            id: "Description",
            class: "form-control",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedRecord.Description) = $event)),
            placeholder: '(' + _ctx.language.description.toLowerCase() + ')',
            maxlength: "500",
            autocomplete: "off",
            onFocus: _cache[13] || (_cache[13] = ($event: any) => (_ctx.selectOnFocus($event))),
            disabled: _ctx.isSavingRecord,
            rows: "3"
          }, null, 40, _hoisted_39), [
            [_vModelText, _ctx.selectedRecord.Description]
          ])
        ])
      ])
    ], 2)
  ]))
}